import React from 'react';
import { ECSegmentListDTO, ECSegmentStatus } from 'core/ecSegment/ECSegment';
import i18n from 'i18n';
import moment from 'moment';
import { CopyableOverlayTrigger } from 'components/CopyableOverlayTrigger/CopyableOverlayTrigger';
import { useCoreContext } from 'contexts/coreContext';
import { MOMENT_TIMEZONE } from 'core';

export const ECSegmentStatusColumn: React.FC<{
  ecSegment: ECSegmentListDTO;
}> = ({
  ecSegment
}) => {

  const core = useCoreContext();
  const localeMeta = core?.accountManager.localeMeta;
  const agencyTimeZone = localeMeta?.timezone ? MOMENT_TIMEZONE[localeMeta.timezone] : MOMENT_TIMEZONE['+08:00'];
  const localExpiredTime: moment.Moment = moment.tz(ecSegment.expiredTime, agencyTimeZone).local();
  const now: moment.Moment = moment();
  const expiringDuration = localExpiredTime.startOf('day').diff(now.startOf('day'), 'days');
  const isUnbound = ecSegment.status === ECSegmentStatus.UNBOUND;
  const statusContent = i18n.t<string>(`ecSegment.status.${ ecSegment.status}`);

  return (
    <div>
      {(isUnbound && expiringDuration >= 0)
        ? (
          <CopyableOverlayTrigger
            placement='bottom'
            trigger='hover'
            overlay={localExpiredTime.isSame(now, 'day')
              ? i18n.t<string>('ecSegmentList.hints.unBoundExpiryToday', {
                time: `${localExpiredTime.format('HH:mm')}`
              })
              : i18n.t<string>('ecSegmentList.hints.unBoundExpiry', {
                duration: expiringDuration
              })
            }
          >
            {statusContent}
          </CopyableOverlayTrigger>
        )
        : statusContent
      }
    </div>
  );
};

export const renderECSegmentStatusColumn = (
  ecSegment: ECSegmentListDTO
) => {
  return (
    <ECSegmentStatusColumn
      ecSegment={ecSegment}
    />
  );
};
